import React from 'react'
import CustomCursor from '../../Global/Cursor'
import Preloader from '../../Global/Preloader'
import Header from '../../Global/Header1'
import PageInear from '../MenCart/PageInear'
import Cart from '../MenCart/Cart'
import Cta from '../../Global/Cta'
import Footer from '../../Global/Footer1'
import GoToTop from '../../Global/GoToTop'

const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <PageInear />
            <Cart />
            <Cta />
            <Footer />
            <GoToTop />
        </>
    )
}

export default Main
